import { Shell } from "../../../components/ops/Shell";
import { useAuth } from "../../../context/AuthContext";
import { coachNavItems } from "../coachNav";

export function CoachLayout() {
  const { user, signOut } = useAuth();

  return (
    <Shell
      navItems={coachNavItems}
      brandTitle="Formula Soccer"
      brandSubtitle="Coach Portal"
      eyebrow="Coach Portal"
      user={user}
      onSignOut={signOut}
      theme="coach"
    />
  );
}
